export function calcMinutes ({ hour, tomorrow }) {
  const currentMoment = new Date()
  const hoursPart = hour.split(':')
  const goalHour = new Date(
    currentMoment.getFullYear(),
    currentMoment.getMonth(),
    currentMoment.getDate(),
    parseInt(hoursPart[0], 10),
    parseInt(hoursPart[1], 10),
    0
  )

  if (goalHour < currentMoment || tomorrow) {
    // Si la hora determinada ya pasó hoy, consideramos que es para el día siguiente.
    goalHour.setDate(goalHour.getDate() + 1)
  }

  const minutesDiference = Math.floor((goalHour - currentMoment) / (1000 * 60))

  return minutesDiference
}
